module.exports = __webpack_public_path__ + "static/media/Allocated-Funds.9d0f88e3.svg";